import { AfterViewInit, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { RequestLicenseDialogComponent } from './request-license-dialog/request-license-dialog.component';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { HttpService } from 'src/app/shared/services/HttpClientServices/Http.service';
import { AlertsService } from '../shared/services/alertService/alerts.service';
import { LicenseState } from './enums/LicenseState';

export enum LicenseTypes {
  Essential = 1,
  Advanced = 2,
  Ultimate = 3
}
@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss',
})
export class AboutComponent implements AfterViewInit {

  Dialog: any;
  Version: String;
  LicenseType: String;
  LicenseTo: String;

  constructor
    (
      @Inject('CreateDialog') public _CreateDialog,
      private translate: TranslateService,
      private HttpService: HttpService,
      public alert: AlertsService,
    ) {
    this.Dialog = this._CreateDialog();
    this.Version = environment.version;
  }

  ngAfterViewInit(): void {
    this.GetLicenseInfo()
  }

  RequestLicense() {
    this.Dialog.ShowDialog(RequestLicenseDialogComponent,
      {
        currentComponent: this,
      },
      this.translate.instant("RequestLicense"), this.translate.instant("DownloadLicense"), "Cancel", false, true);
  }

  GetLicenseInfo() {
    this.HttpService.get(`api/License/GetLicenseInfo`).subscribe( res=>{
      this.LicenseTo = res?.LicenseTo
      this.LicenseType = LicenseTypes[res?.LicenseType]
    })
  }

  selectedFile: File | null = null;
  @ViewChild('fileInput') fileInput!: ElementRef;

  handleFileUpload() {
    if (this.selectedFile) {
      this.uploadFile();
    } else {
      this.fileInput.nativeElement.click();
    }
  }

  onFileChange(event: any) {
    if (event.target.files.length > 0) {
      this.selectedFile = event.target.files[0];
      this.uploadFile();
    }
  }

  uploadFile() {
    if (!this.selectedFile) return;

    const formData = new FormData();
    formData.append('file', this.selectedFile);

    this.HttpService.add('api/License/upload', formData)
      .subscribe(response => {
        this.selectedFile = null;
        if (response) {
          if (response.Status[0] == LicenseState.NoLicenseFile) {
            this.alert.showAlertMessage(this.translate.instant('InvalidlicenseFile'), 0);
          }
          else if (response.Status[0] == LicenseState.InvalidApplicationPath) {
            this.alert.showAlertMessage(this.translate.instant('InvalidApplicationPath'), 0);
          }
          else if (response.Status[0] == LicenseState.InvalidMachineKey) {
            this.alert.showAlertMessage(this.translate.instant('InvalidMachineKey'), 0);
          }
          else if (response.Status[0] == LicenseState.InvalidCertificateFile) {
            this.alert.showAlertMessage(this.translate.instant('InvalidCertificateFile'), 0);
          }
          else if (response.Status[0] == LicenseState.OldVersion) {
            this.alert.showAlertMessage(this.translate.instant('OldVersion'), 0);
          }
          else if (response.Status[0] == LicenseState.ServerTypeError) {
            this.alert.showAlertMessage(this.translate.instant('ServerTypeError'), 0);
          }
          else {
            this.alert.showAlertMessage(this.translate.instant("LicenseUploadSuccessfully"), 2);
            window.location.reload()
          }
        }
      }, error => {
        this.alert.showAlertMessage(this.translate.instant("File upload failed"), 0);
      });
  }

}
